import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { setupScrollAnimations } from '../utils/scrollAnimations';
import './style.css';

const About = () => {
  const { t } = useTranslation();
  
  useEffect(() => {
    setupScrollAnimations();
  }, []);
  
  return (
    <motion.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className="about-section"
    >
      <div className="about-container">
        {/* Image at the top center */}
        <div className="about-image animate-on-scroll">
          <div className="image-container image-zoom">
            <img src="/about.jpg" alt="About United Ayaat" />
            <div className="image-overlay">
              <div className="overlay-content">
                <h3>Excellence in Every Project</h3>
                <p>Delivering quality since our inception</p>
              </div>
            </div>
          </div>
        </div>

        {/* All text content below the image */}
        <div className="about-text animate-on-scroll">
          <div className="about-intro">
            <h2>{t('about.story')}</h2>
            <p>
              <strong>United Ayaat</strong> {t('about.storyText')}
            </p>
          </div>

          <div className="about-description">
            <p>{t('about.description')}</p>
          </div>

          <div className="about-values">
            <div className="value-item">
              <div className="value-icon">🎯</div>
              <div className="value-content">
                <h3>{t('about.mission')}</h3>
                <p>{t('about.missionText')}</p>
              </div>
            </div>

            <div className="value-item">
              <div className="value-icon">👁️</div>
              <div className="value-content">
                <h3>{t('about.vision')}</h3>
                <p>{t('about.visionText')}</p>
              </div>
            </div>

            <div className="value-item">
              <div className="value-icon">⭐</div>
              <div className="value-content">
                <h3>{t('about.values')}</h3>
                <p>{t('about.valuesText')}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Stats Section */}
      <div className="about-stats animate-on-scroll">
        <div className="stats-container">
          <div className="stat-item animate-fade-in-up animate-delay-1">
            <div className="counter-container">
              <div className="counter" data-target="20">0</div>
              <span className="counter-suffix">+</span>
            </div>
            <div className="stat-label">{t('about.stats.experience')}</div>
          </div>
          <div className="stat-item animate-fade-in-up animate-delay-2">
            <div className="counter-container">
              <div className="counter" data-target="500">0</div>
              <span className="counter-suffix">+</span>
            </div>
            <div className="stat-label">{t('about.stats.projects')}</div>
          </div>
          <div className="stat-item animate-fade-in-up animate-delay-3">
            <div className="counter-container">
              <div className="counter" data-target="50">0</div>
              <span className="counter-suffix">+</span>
            </div>
            <div className="stat-label">{t('about.stats.team')}</div>
          </div>
          <div className="stat-item animate-fade-in-up animate-delay-4">
            <div className="counter-container">
              <div className="counter" data-target="99">0</div>
              <span className="counter-suffix">%</span>
            </div>
            <div className="stat-label">{t('about.stats.satisfaction')}</div>
          </div>
        </div>
      </div>
    </motion.main>
  );
};

export default About;
